
/*
 Author: Vinod
 Date: 03/03/2020
 Issue Description:  Instead of "Value" It shows the criteria chosen in the label.
 search_string: PL_2869
*/


<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <br />

    <tl-header type="h1">
      <div class="main-header margintop-10">Manage Roles</div>
    </tl-header>

    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>

    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      <div>
        <div class="row-container" :disabled="!ifTeamleaderAnchorPermission">
          <div class="row">
            <div class="col-3 padding-l-n">
              <search-dropdown
                class="custom-width-search margin-t-15px"
                :placeholder="'Search Employee Name'"
                :clearRequired="true"
                :employeeData="employeeData"
                @clear="(val) =>{selectedEmployee = {};}"
                @getList="searchEmployeesByName($event)"
                @empselected="(emp)=>selectedEmp(emp)"
              />
            </div>
          </div>
          <div class="row-container end" @click="showPopup = !showPopup ">
            <img src="@/assets/group-5.svg" class="Group-5" />
            <button class="text-green">Add Employee</button>
          </div>
        </div>

        <div class="margintop-20" :disabled="!ifTeamleaderAnchorPermission">
          <data-table
            :columns="employeeTableColumns"
            :tableData="employeeList.active"
            :checkbox="false"
            :withForm="false"
            :showhistory="false"
            :showdelete="false"
            @editStart="initEditStart"
            :search="search"
          >
            <template v-slot:rowcontent="slotprops">
              <p
                v-if="slotprops.value.column.key=='salary_component_code'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>

              <p
                v-if="slotprops.value.column.key=='value'"
              >Rs. {{slotprops.value.record[slotprops.value.column.key]}}</p>

              <div v-if="slotprops.value.column.key=='from'">
                  <span>{{formatDate(slotprops.value.record[slotprops.value.column.key])}}</span>
              </div>

              <div v-if="slotprops.value.column.key=='to'">
                  <span>{{formatDate(slotprops.value.record[slotprops.value.column.key])}}</span>
              </div>
            </template>
          </data-table>
        </div>
      </div>
      <pop-up-window
                v-if="showPopup && selectedEmployee.id != null"
                @back="showPopup = !showPopup"
                :header="headerTextWindow">

                <template v-slot:content>
                  <assign-role :empId="selectedEmployee" @back="showPopup = !showPopup"></assign-role>
                </template>

      </pop-up-window>
    </div>

    <footer>
      <bottom-action-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Back" type="secondary" @click="cancel" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AssignRole from "./assignRole.vue";
import { api_variables } from "@/apis/variables.js";

export default {
  components: {
    AssignRole
  },
  data() {
    return {
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Manage Team Roles",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/manageRoles`
        }
      ],

      errmsg: "",
      toast: false,
      search: "",
      currentMonthValue: "",
      subCriteriaLabel: "", // PL_2869
      body: {
        legal_entity_id: this.le_id,
        paygroups: [],
        bands: [],
        bunits: [],
        locs: [],
        cost_centers: []
      },

      formData: {
        payGroupObj: null,
        criteriaObj: null,
        valueObj: null
      },

      criteriaArray: [
        { name: "Location" },
        { name: "Salary Band" },
        //{ name: "Grade" },
        { name: "Cost Centre" },
        { name: "BUs" }
      ],

      valueArray: [],

      payGroupsList: [],

      criteriaList: [],

      valueList: [],

      employeeTableColumns: [
        {
          label: "Name",
          key: "salary_component_code"
        },
        {
          label: "Email ID",
          key: "from"
        },
        {
          label: "Code",
          key: "to"
        },
        {
          label: "Mobile No",
          key: "value"
        },
        {
          label: "Role",
          key: "from"
        },
        {
          label: "Permission",
          key: "to"
        },
        {
          label: "Status",
          key: "value"
        }
      ],

      employeeList: [],

      monthOptions: [
        { name: "January", id: "jan" },
        { name: "February", id: "feb" },
        { name: "March", id: "march" },
        { name: "April", id: "apr" },
        { name: "May", id: "may" },
        { name: "June", id: "june" },
        { name: "July", id: "july" },
        { name: "August", id: "aug" },
        { name: "September", id: "sept" },
        { name: "October", id: "oct" },
        { name: "November", id: "nov" },
        { name: "December", id: "dec" }
      ],
      activeComponentsCountArray: [],
      tabs: [
        {
          header: "Active"
        },
        {
          header: "Scheduled"
        },
        {
          header: "Expired"
        }
      ],
      showPopup: false,
      employeeData: [],
      selectedEmployee: {},
      bulkUploadUrl: api_variables.SERVICE_EMPLOYEES_BULK_NON_CTC,
      manageRolesValue: false,
      role: ""
    };
  },

  mounted() {
    this.fetchRoleDetails();
    this.getOrgLeIdList();
  },

  activated() {
    this.refresh();
    var today = new Date();
    let currentMonthIndex = today.getMonth();
    this.currentMonthValue = this.monthOptions[currentMonthIndex].name;
    this.fetchRoleDetails();
    this.getOrgLeIdList();
  },

  computed: {
    ...mapState({
      business_units: state => state.onboard.business_units.data,
      salary_bands: state => state.onboard.salary_bands.data,
      locations: state => state.onboard.locations.data,
      salary_grades: state => state.onboard.salary_grades.data,
      cost_centres: state => state.onboard.cost_centres.data,
      employees: state => state.onboard.employees.entityWiseData,

      globalEmployeeList: state =>
        state.globalapi.globalemployees.entityWiseData
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    headerTextWindow() {
      if (this.selectedEmployee) {
        return `Manage Role: ${ this.selectedEmployee.first_name }`;
      } else {
        return `Manage Role: ${ this.selectedEmployee.first_name }`;
      }
    },
    requestParams() {
      return {
        le_id: this.le_id
      };
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.manageRolesValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },

  methods: {
    ...mapActions({
      fetch_assigned_components: "dashboard/payroll/utilities/get_fbp/fetchAll",
      assign_component:
        "dashboard/payroll/utilities/assignfbpcomponents/create",
      act_fetchAllEmployees: "globalapi/globalemployees/fetchAll",
      act_fetchRoles:
        "dashboard/payroll/utilities/manageRoles/fetchAll",
      act_locations_fetchAll: "onboard/locations/fetchAll",
      act_costCenters_fetchAll: "onboard/cost_centres/fetchAll",
      act_salaryBands_fetchAll: "onboard/salary_bands/fetchAll",
      act_businessUnits_fetchAll: "onboard/business_units/fetchAll",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
    }),

    edit(record) {},

    unAssign(record) {},

    async fetchRoleDetails() {
      this.employeeList = [];
      try {
        let res = await this.act_fetchRoles({
          le_id: this.le_id,
        });
        //console.log({res});
        // this.employeeData = res.data.payload;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    onUploadTemplate() {
      try {
        let formData = new FormData();
        formData.append("file", event);
        formData.append("le_id", this.le_id);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to select employee */
    async selectedEmp(emp) {
      try {
        this.selectedEmployee = emp
        this.empId = emp.id;
        this.empCode = emp.code;
        this.empName = emp.first_name + ' ' + emp.last_name;   // PL_3009
        this.empMail = emp.email_id;
        let res = await this.fetchNonCtcComponents(emp.id);
        this.employeeList = res.data.payload.data;
        // if (this.typeOfLoss) {
        //   this.fetchAll();
        // }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async searchEmployeesByName(val) {
      //console.log({val});
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val
        });
        this.employeeData = res.data.payload;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async changeCriteria(event) {
      try {
        if (event) {
          this.valueArray = [];
          this.formData.criteriaObj = event;
          this.formData.valueObj = [];
          this.subCriteriaLabel = event.name; // PL_2869
          if (event.name == "Location") {
            try {
              let res = await this.act_locations_fetchAll(this.le_id);
            } catch (err) {
              this.toast = true;
              this.errmsg = err;
            }

            this.valueArray = this.locations[this.le_id]
              ? this.locations[this.le_id]
              : [];
          } else if (event.name == "Salary Band") {
            try {
              let res = await this.act_salaryBands_fetchAll(this.le_id);
            } catch (err) {
              this.toast = true;
              this.errmsg = err;
            }

            this.valueArray = this.salary_bands[this.le_id]
              ? this.salary_bands[this.le_id]
              : [];
          } else if (event.name == "Grade") {
            this.valueArray = this.salary_grades[this.le_id]
              ? this.salary_grades[this.le_id]
              : [];
          } else if (event.name == "Cost Centre") {
            try {
              let res = await this.act_costCenters_fetchAll(this.le_id);
            } catch (err) {
              this.toast = true;
              this.errmsg = err;
            }

            this.valueArray = this.cost_centres[this.le_id]
              ? this.cost_centres[this.le_id]
              : [];
          } else if (event.name == "BUs") {
            try {
              let res = await this.act_businessUnits_fetchAll(this.orgId);
            } catch (err) {
              this.toast = true;
              this.errmsg = err;
            }

            this.valueArray = this.business_units.data
              ? this.business_units.data
              : [];
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    changeValue(event) {
      try {
        if (event) {
          this.body.locs = [];
          this.body.bands = [];
          this.body.bunits = [];
          this.body.cost_centers = [];

          let valueArr = event;

          if (this.formData.criteriaObj.name == "Location") {
            valueArr.forEach(item => {
              this.body.locs.push(item.id);
            });
          } else if (this.formData.criteriaObj.name == "Salary Band") {
            valueArr.forEach(item => {
              this.body.bands.push(item.id);
            });
          } else if (this.formData.criteriaObj.name == "Cost Center") {
            valueArr.forEach(item => {
              this.body.cost_centers.push(item.id);
            });
          } else if (this.formData.criteriaObj.name == "BUs") {
            valueArr.forEach(item => {
              this.body.bunits.push(item.id);
            });
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    payGroupChanged(event) {
      this.body.paygroups = [event.id];
    },

    filterData(searchText) {
      this.search = searchText;
    },

    filterList() {
      // this.fetchEmplDetails();
    },

    async initEditStart(record) {
      try {
        let selectedindex = this.employeeList.findIndex(
          item => item.id == record.id
        );

        if (selectedindex > -1) {
          try {
            await this.act_changeEditMode({
              editMode: true,
              record: record,
              index: selectedindex
            });
            this.$router.push({
              path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
            });
          } catch (err) {
            this.toast = true;
            this.errmsg = err.message;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    formatDate(date) {
      let dateJsObj = new Date(date);
      return `${dateJsObj.getDate()}/${dateJsObj.getMonth()+1}/${dateJsObj.getFullYear()}`;
    },

    cancel() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
      });
      // this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
      // });
    },

    refresh() {
      try {
        this.formData = {
          payGroupObj: null,
          criteriaObj: null,
          valueObj: null
        };
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.manageRolesValue = data.data.user.permissions.manage_roles ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>

.tabs .tab-container {
  padding: none;
}

.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 10px;
  color: #6e6e6e;
}

.uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
}

.form-button {
  margin-top: 10px;
  margin-bottom: 5%;
}

.customColumnGrid {
  display: grid;
  grid-template-columns: 15% 15% 15% 15%;
  grid-row-gap: 15px;
  grid-column-gap: 20px;
}

.emp-image{
    width: 80px;
    height: 80px;
    border-radius: 40px;
}
.end {
  justify-content: flex-end;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
